// extracted by mini-css-extract-plugin
export default {"basePolicyHeader":"CommonPolicyStyles_basePolicyHeader__DG1LT","policyBtn":"CommonPolicyStyles_policyBtn__xh62h"};